
<appbar (myEvent)="refreshPage()" [customBack]="goToCustomRoute">{{ gameName }}</appbar>
<div class="main__wrapper">
  <div class="header">
    <!--Content before waves-->
    <div class="row" *ngIf="!isUserLoggedIn">
      <div class="col-12 my-2 text-left">
        <a (click)="loginAccount()" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <div class="d-flex align-items-center">
            <ion-icon name="person-circle-outline" class="account-login"> </ion-icon>
            <h5 class="account_login_text">{{ 'click_to_login' | translate}}</h5>
          </div>
        </a>

      </div>
    </div>

    <div class="p-3" *ngIf="isUserLoggedIn">
      <a [routerLink]="['/wallet/game-wallet',providerId]" replaceUrl="true" [state]="{parentLink: gameLink}">
        <div class="card game__list_balance">
          <div class="card-body p-0">
            <div class="container">
              <div class="row align-items-center">
                <div class="col-8">
                  <div class="container">
                    <div class="row walletlbl">
                    <div class="col-12 ml-auto d-flex align-items-center " >
                      <ion-icon name="wallet-outline" class="active-wallet"></ion-icon>
                      <!-- <img src = './assets/img/activewallet.png'  class="active-wallet"/> -->
                      <span class="child-walletlbl pt-1">{{ 'mainWallet' | translate}} &nbsp;&nbsp;&nbsp;
                        {{userProfileBalance | number : 0}}</span>

                    </div>
                  </div>

                  <div class="row walletlbl">
                    <div class="col-12 ml-auto d-flex align-items-center" >
                      <img src='./assets/img/game_wallet.png' class="active-wallet" />
                      <span class="child-walletlbl pt-1">{{ gameName }}({{ 'ks' | translate}}) &nbsp;&nbsp;&nbsp;
                        {{gameUserBalance}}</span>
                    </div>

                  </div>
                  </div>
                 
                </div>
                <div class="col-4 d-flex justify-content-end">
                  <ion-icon name="chevron-forward-outline"></ion-icon>
                </div>                 
              </div>
            </div>           
          </div>
        </div>
      </a>
    </div>


    <div class="slider">
      <owl-carousel-o [options]="customOptions">
        <ng-container *ngIf="adsList != ''">
          <ng-template carouselSlide *ngFor="let adsObj of adsList;trackBy: gameAdsListId">
            <div class="slide">
              <img [src]="adsObj.imageUrl" alt="AdsImage">
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>

      <div class="overlay" *ngIf="marqueeText != null">
        <marquee direction="left"><h5>{{marqueeText.marqueeText}}</h5></marquee>
      </div>
    </div>
    <!--Waves Container-->
    <div>
      <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
        <defs>
          <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="parallax">
          <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7)" />
          <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
          <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
          <use xlink:href="#gentle-wave" x="48" y="7" fill="#fff" />
        </g>
      </svg>
    </div>
    <!--Waves end-->
  </div>
  <!-- end header -->

  <div class="row  mt-5 game__list__box" *ngIf="gameList != null && gameList.isMaintenance == false && gameList.status == 'ACTIVE'">  
    <!-- <img  *ngIf = "(gameList.titleimageUrl !=null && gameList.titleimageUrl?.length > 0)" [src] = 'gameList.titleimageUrl'
        class ="gameTitleImgClass"> -->
    <div class="container px-4 ">
      <!-- gameList.gsGameList.length -->
      <div class="row my-3" *ngIf="gameItems.length > 10">
        <div class="game-searching-col">
          <input type="text" placeholder="Search.." (keyup)="search()" [(ngModel)]="searchKey"
            [ngModelOptions]="{standalone: true}" class="game-searching">
          <ion-icon name="search-outline" class="game-searching-icon"></ion-icon>
        </div>

      </div>
      <div class="row text-center" [ngClass]="{ 'mt-4': gameItems.length < 10 }">
        <div class="col-4 mb-3" *ngFor="let gameObj of gameItems;trackBy: gameItemsId" >
           <div class="game__item" (click)="showplayFreeOrplay(playFreeOrPlay,transferAlert,gameObj.supportdemourl,gameObj.code,gameObj.providercode,gameObj)">
             <div class="game__hot" *ngIf="gameObj.isHot == 'true'"></div>
             <div class="panel__img">     
              <img class="game-image" [src]="gameObj.iconurl != ''? gameObj.iconurl: 'assets/img/no_image.png'" [alt]="gameObj.name" >                                       
             </div>            
             <h5 class="text-wrap">{{ changeLanguage(gameObj)}}</h5>
           </div>          
        </div>
      </div>
    </div>
  </div>
 
  <!-- App Maintain Capsule -->
   
  <div  *ngIf="gameList != null  && gameList.isMaintenance && gameAlertObject.status =='ACTIVE'">
    <img [src]="gameList.titleimageUrl"
      *ngIf="(gameList.titleimageUrl !=null && gameList.titleimageUrl?.length > 0)" class="gameTitleImgClass">
    <div class="container" *ngIf="gameAlertObject !=null">
      <div class="row mx-2">
        <div class="col-4 maintenanceClass pt-2">
          <img *ngIf=" (gameAlertObject.imageUrl == null && gameAlertObject.imageUrl?.length == 0)"
            src='assets/img/maintenance.png' width="100px" height="100px" />
          <img *ngIf=" (gameAlertObject.imageUrl != null && gameAlertObject.imageUrl?.length != 0)"
            [src]='gameAlertObject.imageUrl' width="100px" height="100px" class='gameAlertImg' />
        </div>
        <p class="text-warning text-center">{{gameAlertObject.description_en}}</p>
      </div>
    </div>

  </div>
  <!-- * App Maintain Capsule -->
</div>

<!-- Play free or play Modal -- not user this -->
<div class="modal fade" id="playFreeOrplay" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content playFreeOrPlay">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <button type="button" class="btn btn-success btn-lg btnAction" data-dismiss="modal" (click)="playFree()">{{
            'play_free' | translate}}</button>
        </div>
        <div class="row py-3">
          <button type="button" class="btn btn-success btn-lg btnAction" (click)="play(transferAlert)">{{ 'play' |
            translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- * Play free or play -->

<!-- Pls topup alert -->
<ng-template #transferAlert>  
  <div class="modal-body">   
    <div class="container p-0">
      <div class="row position-relative">
        <ion-icon name="close-circle-outline" (click)="HideAlert()" class="close__icon"></ion-icon>       
      </div>
      <p class="text-center mt-5 mb-2">{{ 'gametransactionAlert' | translate}}</p>
      <div class="row align-items-center ">
        <div class="col-5 text-right">  
          <img src='assets/img/game_kyat.png' width="30" />        
          <span class="child-walletbalance">{{userProfileBalance | number : 0}} </span>
        </div>
        <div class="col-2 text-center">
          <img src="assets/img/game__transfer.png" alt="" width="50">
        </div>
        <div class="col-5 text-left">
           <img src='assets/img/game_wallet.png' width="30" />
           <span class="child-walletbalance">{{ gameUserBalance | number : 0}} </span>
        </div>
      </div>      
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="openGame('free')">{{ 'game_view' |
      translate}}</button>
    <button type="button" class="btn btn-primary" (click)="goToGameWallet()">{{ 'game_balance_transfer' |
      translate}}</button>
  </div>

</ng-template>

<!-- playFreeOrPlay alert use this -->
<ng-template #playFreeOrPlay>
  <div class="modal-header"> 
    <div class="close pull-right">
      <ion-icon name="close-circle-outline" (click)="HidePlayFreeOrPlayAlert()" class="text-danger"></ion-icon>
    </div>   
  </div>
  <div class="modal-body">
    <div class="row">
      <button type="button" class="btn btn-primary btn-block mx-3 play_free_bg" (click)="playFree()">
        <ion-icon name="play-circle-outline"></ion-icon>&nbsp;{{ 'play_free' | translate}}
      </button>
      <button type="button" class="btn btn-primary btn-block mx-3 align-items-center" (click)="play(transferAlert)">
        <ion-icon name="play-circle-outline"></ion-icon> &nbsp;{{ 'play' | translate}}
      </button>
    </div>    
  </div> 
</ng-template>

<ngx-spinner name="refreshLoading" bdOpacity=0.9 size="medium" color="#00acc1" type="ball-spin-clockwise"
  [fullScreen]="true"></ngx-spinner>